import { create, filter, findAll, findOne, getOne, resetSave, resetList, update } from "@/store/Crud/functions/actions";
export default {
    create,
    filter,
    findOne,
    update,
    findAll,
    getOne,
    resetSave,
    resetList,
};
